<template>
  <div class='flex rounded-md shadow-sm'>
    <label :for='labelId' class='inline-flex items-center rounded-l-md border border-r-0 border-gray-300 px-3 text-gray-500 sm:text-sm'>{{ props.label }}</label>
    <input type='number' :id='labelId' class='block w-full min-w-0 flex-1 rounded-none rounded-r-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6' v-model='model' />
  </div>
</template>

<script setup>

import { nanoid } from 'nanoid';

const model = defineModel();

const labelId = nanoid();

const props = defineProps({
  label: String
});

</script>